import type { UIInventoryItem } from '@sorrem-client/types';
import { Button } from '@sorrem/ui';
import { CrystalIcon } from '@sorrem-client/ui/components/CrystalIcon';
import styles from './CrystalStackHeader.module.scss';

interface CrystalStackHeaderProps {
    /** A carried crystal stack (`item.crystal` is set). */
    item: UIInventoryItem;
    /** The stack's action: Use in a run, Remove on the gathering page. */
    actionLabel: string;
    onAction: () => void;
    /** Drops the whole stack on the ground (in a run); no Drop button when unset. */
    onDrop?: () => void;
}

/** A selected crystal stack: what it is, how many, and its action. */
export function CrystalStackHeader({ item, actionLabel, onAction, onDrop }: CrystalStackHeaderProps): JSX.Element | null {
    if (item.crystal === undefined) {
        return null;
    }

    return (
        <section className={styles.crystalStackHeader} aria-label={item.name}>
            <span className={styles.icon}>
                <CrystalIcon crystalType={item.crystal.crystalType} size={item.crystal.size} />
            </span>
            <div className={styles.info}>
                <h3 className={styles.name}>{item.name}</h3>
                <p className={styles.count}>{`${item.qty} carried - bound to this Crucible`}</p>
                {item.crystal.description && <p className={styles.effect}>{item.crystal.description}</p>}
            </div>
            <div className={styles.actions}>
                <Button onClick={onAction}>{actionLabel}</Button>
                {onDrop !== undefined && <Button variant='secondary' onClick={onDrop}>Drop</Button>}
            </div>
        </section>
    );
}
